import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import Tag from "../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../app/data/common/tagColor";

const columnHelper = createColumnHelper<any>();

const getRouteGuideActivityLogColumns = () => [
  columnHelper.accessor("changedAt", {
    id: "changedAt",
    header: "Timestamp",
    cell: (cellProps) => {
      const value = cellProps.getValue();
      const date = new Date(value);
      const formattedParts = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      const formattedDate = date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "2-digit",
      });

      return (
        <div>
          <span>{formattedDate} </span>
          <span className="xgs-route-guide-activitylog__formatedtime">{formattedParts}</span>
        </div>
      );
    },
    enableColumnFilter: false,
    size: 170,
  }),
  columnHelper.accessor("zipLabel", {
    id: "zipLabel",
    header: "ZIP / Terminal",
    cell: (cellProps) => {
      const row = cellProps.row.original;
      return (
        <div className="row">
          {row.zipLabel}
          {row.terminalNumber != null && (
            <span className="xgs-route-guide-activitylog__formatedtime">
              {row.terminalNumber}
            </span>
          )}
        </div>
      );
    },
    enableColumnFilter: false,
    size: 180,
  }),
  columnHelper.accessor("action", {
    id: "action",
    header: "Action",
    cell: (cellProps) => {
      const action = String(cellProps.row.original?.action ?? "").toUpperCase();
      const actionColorMap: Record<string, TagColor> = {
        UPDATE: TagColor.ORANGE,
        CREATE: TagColor.GREEN,
        DELETE: TagColor.RED,
      };
      return (
        <Tag mods={{ color: actionColorMap[action] || TagColor.GREY }}>{action}</Tag>
      );
    },
    enableColumnFilter: false,
    size: 90,
  }),
  columnHelper.accessor("modifiedBy", {
    id: "modifiedBy",
    header: "Changed By",
    enableColumnFilter: false,
    size: 170,
  }),
  columnHelper.accessor("changeDescription", {
    id: "changeDescription",
    header: "Description",
    enableColumnFilter: false,
    size: 270,
  }),
];

export default getRouteGuideActivityLogColumns;
